import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {
    Header, 
    SubHeader,
    Paragraph, 
    NavigationLinkButton,
    CorrespondenceAddressComponent
} from '../../components/RegularComponents'
import { confirmApplicationSubmissionSelect } from '../../redux/selector/confirmApplicationSubmissionSelector';
import {replaceUrlParams} from '../../app/utils'
import Navigation from '../Navigation';
import {resetWelcomeDialogDisplay} from '../../redux/slice/welcomeSlice'
//import { APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY } from '../../app/constants';

const ConfirmApplicationSubmission = (props) => {
    const {confirmApplicationSubmission} = props
    const {applicationType, applicationMode} = props.match.params

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                {/* <TopNavigationBar {...props} /> */}
                <div className="row">
                    <div className="col-lg-8">
                        <Header header = {confirmApplicationSubmission.header} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8">
                        <SubHeader subHeader = {confirmApplicationSubmission.subHeader} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8">
                        <Paragraph text = {confirmApplicationSubmission.text} />
                    </div>
                </div>
                {CorrespondenceAddressComponent()}
                <div className="row bottomMarginMedium">
                    <div className="col-8">
                        Missing this step will cause a delay in issuing your licence.
                    </div>
                </div>
                <div className="row bottomMarginMedium">
                    <div className="col-8">
                        <NavigationLinkButton 
                            id="cofirm-app-submittion-next-button"
                            text={"Go to service home page"}
                            onClick={() => {
                                props.dispatch(resetWelcomeDialogDisplay(applicationType))
                                props.dispatch(push(replaceUrlParams(confirmApplicationSubmission.navigation.next,applicationType, applicationMode)))
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(confirmApplicationSubmissionSelect)(ConfirmApplicationSubmission)
